import { CButton, CCol, CLabel, CRow } from "@coreui/react";
import React from "react";
import Auth from "src/auth";
import { red } from "@mui/material/colors";
import { useHistory } from "react-router-dom";

const LotListViewEMDAndSecurityDepositPayment = (props) => {
  const { authenticated } = Auth();
  let history = useHistory();

  const ChequePaymentHandler = async () => {
    history.push(`/OfflinePaymentWithTypeCheque/${props.lotId}`, {
      from: window.location.href,
    });
  };

  return (
    <>
      {props.viewListDetails &&
      authenticated.role === "Bidder" &&
      props.viewListDetails.addAmount > 0 &&
      props.viewListDetails.lotTransferCount === 0 ? (
        <>
          {props.EmdPaid.isEMDPaid === false ? (
            <>
              <CRow className="pt-3 pl-1 pr-1 mt-3">
                <CCol className="mb-2" xl={12}>
                  <h3 className="titlehr">EMD Payment</h3>
                </CCol>
              </CRow>

              <CRow className="pl-1 pr-1">
                <CCol xl={12}>
                  {/* //props.viewListDetails.isChequePaymentDone */}
                  {props.viewListDetails?.chequePaymentNotes !== null &&
                    props.viewListDetails?.chequePaymentNotes !== "" &&
                    props.EmdPaid.lotPaymentViewModel?.paymentNotes !==
                      props.viewListDetails?.chequePaymentNotes && (
                      <>
                        {props.viewListDetails?.chequePaymentNotes}
                        <br />
                      </>
                    )}
                  {props.EmdPaid.lotPaymentViewModel?.paymentNotes !== null &&
                  props.EmdPaid.lotPaymentViewModel?.paymentNotes !== ""
                    ? props.EmdPaid.lotPaymentViewModel?.paymentNotes
                    : "You have to pay additional amount (" +
                      props.viewListDetails.addAmount +
                      ") for security to proceed further."}
                  {props.viewListDetails.emdButtonDisableReason !== "" && (
                    <>
                      <br />
                      <CLabel
                        style={{ color: red }}
                        htmlFor="exampleFormControlInput1"
                      >
                        {
                          <strong>
                            {props.viewListDetails.emdButtonDisableReason}
                            {/* {" "}
                    "You can not complete EMD Payment. Payment has to
                    be complete before 30 days after Saction letter
                    generates." */}
                          </strong>
                        }
                      </CLabel>
                    </>
                  )}
                </CCol>
                <CCol xl={12} className={"mt-3"}>
                  <CButton
                    color="success"
                    disabled={
                      props.viewListDetails.disableEMDPayment ||
                      props.viewListDetails.isLotLeftHOApproval === true
                    }
                    onClick={() =>
                      props.ConfirmationPopupHandler(
                        1,
                        1,
                        "Are you sure you want to pay EMD Payment via Online ?",
                        props.viewListDetails.addAmount,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        false,
                        ""
                      )
                    }
                  >
                    Pay
                  </CButton>
                  {props.EmdPaid.lotPaymentViewModel
                    .isAnyPaymentTransactionDone && (
                    <CButton
                      color="info"
                      className="ml-2"
                      onClick={() =>
                        props.ViewBankTransaction(
                          props.EmdPaid.lotPaymentViewModel.id,
                          "LT"
                        )
                      }
                    >
                      History
                    </CButton>
                  )}
                  <CButton
                    className="ml-2"
                    disabled={
                      props.viewListDetails.disableEMDPayment === true ||
                      props.viewListDetails.isLotLeftHOApproval === true
                        ? true
                        : props.EmdPaid.lotPaymentViewModel.type === 5 &&
                          props.viewListDetails.emdbgid !== "" &&
                          props.viewListDetails.emdStatusCode !== "Rejected"
                        ? true
                        : false
                    }
                    // hidden={
                    //   props.viewTransferDetails.length === 0 &&
                    //   props.viewListDetails.lotTransferCount == 0
                    //     ? false
                    //     : true
                    // }
                    onClick={() =>
                      props.BGPaymentHandler(props.viewListDetails.lotId, "EDI")
                    }
                    color="success"
                  >
                    Bank Guarantee Payment
                  </CButton>
                  <CButton
                    className="ml-2"
                    disabled={
                      props.viewListDetails.disableEMDPayment === true ||
                      props.viewListDetails.isLotLeftHOApproval === true
                        ? true
                        : props.viewListDetails.isChequePaymentDone === true
                        ? true
                        : props.EmdPaid.lotPaymentViewModel.type === 3 &&
                          props.viewListDetails.emdChequeNo !== "" &&
                          props.viewListDetails.emdStatusCode !== "Rejected"
                        ? true
                        : false
                    }
                    // hidden={
                    //   props.EmdPaid.lotPaymentViewModel
                    //     .isAnyPaymentTransactionDone ||
                    //   (props.EmdPaid.lotPaymentViewModel.paidBy !== null &&
                    //     props.EmdPaid.lotPaymentViewModel.paidBy > 0 &&
                    //     props.EmdPaid.lotPaymentViewModel.type !== 3)
                    //     ? true
                    //     : false
                    // }
                    onClick={ChequePaymentHandler}
                    color="success"
                  >
                    Cheque Payment
                  </CButton>
                </CCol>
              </CRow>
            </>
          ) : authenticated.role === "Bidder" &&
            props.viewListDetails.status !== "Terminated" &&
            props.EmdPaid.lotPaymentViewModel?.isPayNowAllow &&
            props.viewTenderDetails.isAgreementLetterGenerated &&
            props.viewListDetails.isAgreementAccepted === 1 ? (
            <>{props.EmdPaid.isEmdPaid}</>
          ) : props.EmdPaid.lotPaymentViewModel?.paymentNotes !== "" &&
            !props.EmdPaid.lotPaymentViewModel?.paymentNotes?.includes(
              "Challan"
            ) &&
            props.EmdPaid.lotPaymentViewModel?.tranId !== null ? (
            <CRow className="mt-4 pl-1 pr-1 col-xl-12">
              <CCol xl={12} className="mb-2">
                {props.EmdPaid.lotPaymentViewModel?.paymentNotes !== null &&
                props.EmdPaid.lotPaymentViewModel?.paymentNotes !== "" ? (
                  // && props.viewTransferDetails.length === 0 &&
                  // props.viewListDetails.lotTransferCount < 2
                  <>
                    <h3 className="titlehr">Security Deposit Payment</h3>
                    {props.EmdPaid.lotPaymentViewModel?.paymentNotes}
                    {props.viewListDetails?.chequePaymentNotes !== null &&
                      props.viewListDetails?.chequePaymentNotes !== "" &&
                      props.EmdPaid.lotPaymentViewModel?.paymentNotes !==
                        props.viewListDetails?.chequePaymentNotes && (
                        <>
                          <br />
                          {props.viewListDetails?.chequePaymentNotes}
                        </>
                      )}
                  </>
                ) : props.viewTransferDetails.length === 0 ? (
                  "You have to pay additional amount for security to proceed further."
                ) : (
                  ""
                )}

                <CButton
                  color="info"
                  hidden={
                    props.EmdPaid.lotPaymentViewModel.paidBy !== null &&
                    props.EmdPaid.lotPaymentViewModel.paidBy > 0
                      ? false
                      : true
                  }
                  onClick={() =>
                    props.PaymentStatusViewHanlder(
                      props.EmdPaid.lotPaymentViewModel?.tranId
                    )
                  }
                  className="mr-5 mt-1 float-right"
                >
                  View Receipt
                </CButton>
                {props.EmdPaid.lotPaymentViewModel.paidBy !== null &&
                  props.EmdPaid.lotPaymentViewModel.paidBy > 0 && (
                    <CButton
                      color="info"
                      className="mr-2 mt-1 ml-1 float-right"
                      // hidden={
                      //   props.EmdPaid.lotPaymentViewModel.paidBy !== null &&
                      //   props.EmdPaid.lotPaymentViewModel.paidBy > 0
                      //     ? false
                      //     : true
                      // }
                      onClick={() =>
                        props.ViewBankTransaction(
                          props.EmdPaid.lotPaymentViewModel.id,
                          "LT"
                        )
                      }
                    >
                      History
                    </CButton>
                  )}
              </CCol>
            </CRow>
          ) : authenticated.role === "Bidder" &&
            props.EmdPaid.lotPaymentViewModel?.paymentNotes !== "" &&
            props.EmdPaid.lotPaymentViewModel?.paymentNotes?.includes(
              "Challan"
            ) &&
            props.EmdPaid.lotPaymentViewModel?.paymentNotes?.includes(
              "Awaiting"
            ) ? (
            <>
              <CRow className="pt-3 pl-5 pr-5 mt-3">
                <CCol className="mb-3" xl={12}>
                  <h3>Emd Payment</h3>
                  <hr></hr>
                </CCol>
              </CRow>
              <CRow className="pl-5 pr-5">
                <CCol xl={6} className="mt-4">
                  {props.EmdPaid.lotPaymentViewModel?.paymentNotes !== null &&
                  props.EmdPaid.lotPaymentViewModel?.paymentNotes !== ""
                    ? props.EmdPaid.lotPaymentViewModel?.paymentNotes
                    : "You have to pay additional amount for security to proceed further."}
                  <br />
                  <CButton
                    color="info"
                    onClick={() =>
                      props.PaymentStatusViewHanlder(
                        props.EmdPaid.lotPaymentViewModel?.tranId
                      )
                    }
                    className="mr-5 mt-1 float-right"
                  >
                    View Receipt
                  </CButton>
                  <CButton
                    color="info"
                    className="mr-2 mt-1 ml-1 float-right"
                    hidden={
                      props.EmdPaid.lotPaymentViewModel.paidBy !== null &&
                      props.EmdPaid.lotPaymentViewModel.paidBy > 0
                        ? false
                        : true
                    }
                    onClick={() =>
                      props.ViewBankTransaction(
                        props.EmdPaid.lotPaymentViewModel.id,
                        "LT"
                      )
                    }
                  >
                    History
                  </CButton>
                  <CButton
                    color="info"
                    onClick={() =>
                      props.CancelChallanHanlder(
                        props.EmdPaid.lotPaymentViewModel?.paymentId
                      )
                    }
                    className="mr-5 mt-1 float-right"
                  >
                    Cancel Challan
                  </CButton>
                </CCol>
              </CRow>
            </>
          ) : props.EmdPaid.lotPaymentViewModel?.paymentNotes !== "" &&
            props.EmdPaid.lotPaymentViewModel?.paymentNotes?.includes(
              "Challan"
            ) &&
            !props.EmdPaid.lotPaymentViewModel?.paymentNotes?.includes(
              "Awaiting"
            ) ? (
            <CRow className="pl-1 pr-1 mt-3">
              <CCol xl={12} className="mt-4">
                {props.EmdPaid.lotPaymentViewModel?.paymentNotes !== null &&
                props.EmdPaid.lotPaymentViewModel?.paymentNotes !== ""
                  ? props.EmdPaid.lotPaymentViewModel?.paymentNotes
                  : "You have to pay additional amount for security to proceed further."}
                <CButton
                  color="info"
                  onClick={() =>
                    props.PaymentStatusViewHanlder(
                      props.EmdPaid.lotPaymentViewModel?.tranId
                    )
                  }
                  className="mr-5 float-right"
                >
                  View Receipt
                </CButton>
                <CButton
                  color="info"
                  className="mr-2 ml-2 float-right"
                  hidden={
                    props.EmdPaid.lotPaymentViewModel.paidBy !== null &&
                    props.EmdPaid.lotPaymentViewModel.paidBy > 0
                      ? false
                      : true
                  }
                  onClick={() =>
                    props.ViewBankTransaction(
                      props.EmdPaid.lotPaymentViewModel.id,
                      "LT"
                    )
                  }
                >
                  History
                </CButton>
              </CCol>
            </CRow>
          ) : (
            authenticated.role !== "CGMF" && (
              <CRow className="pl-1 pr-1 mt-3">
                <CCol xl={12} className="mt-4">
                  {props.EmdPaid.lotPaymentViewModel?.paymentNotes !== null &&
                  props.EmdPaid.lotPaymentViewModel?.paymentNotes !== "" &&
                  props.viewTransferDetails.length === 0 ? (
                    <>
                      <strong>Security Deposit Payment</strong>
                      <hr></hr>
                      {props.EmdPaid.lotPaymentViewModel?.paymentNotes}
                      {props.viewListDetails?.chequePaymentNotes !== null &&
                        props.viewListDetails?.chequePaymentNotes !== "" &&
                        props.EmdPaid.lotPaymentViewModel?.paymentNotes !==
                          props.viewListDetails?.chequePaymentNotes && (
                          <>
                            <br />
                            {props.viewListDetails?.chequePaymentNotes}
                          </>
                        )}
                    </>
                  ) : props.viewTransferDetails.length === 0 ? (
                    "You have to pay additional amount for security to proceed further."
                  ) : (
                    ""
                  )}

                  {props.EmdPaid.lotPaymentViewModel?.paymentNotes !== "" &&
                  props.EmdPaid.lotPaymentViewModel?.tranId !== null ? (
                    <>
                      <CButton
                        color="info"
                        onClick={() =>
                          props.PaymentStatusViewHanlder(
                            props.EmdPaid.lotPaymentViewModel?.tranId
                          )
                        }
                        className="mr-5 mt-2 float-right"
                      >
                        View Receipt
                      </CButton>
                      <CButton
                        color="info"
                        className="mr-2 mt-1 ml-1 float-right"
                        hidden={
                          props.EmdPaid.lotPaymentViewModel.paidBy !== null &&
                          props.EmdPaid.lotPaymentViewModel.paidBy > 0
                            ? false
                            : true
                        }
                        onClick={() =>
                          props.ViewBankTransaction(
                            props.EmdPaid.lotPaymentViewModel.id,
                            "LT"
                          )
                        }
                      >
                        History
                      </CButton>
                    </>
                  ) : (
                    // <a
                    //   target="_blank"
                    //   href={`${downloadUrl}/${props.EmdPaid.lotPaymentViewModel.filePath}`}
                    //   rel="noreferrer"
                    // >
                    props.EmdPaid.lotPaymentViewModel.filePath !== null && (
                      <CButton
                        color="info"
                        className="mr-5 mt-1 float-right"
                        onClick={() =>
                          props.BGPaymentStatusViewHanlder(
                            props.EmdPaid.lotPaymentViewModel.filePath
                          )
                        }
                      >
                        View BG
                      </CButton>
                    )
                    // </a>
                  )}
                </CCol>
              </CRow>
            )
          )}
        </>
      ) : props.viewListDetails &&
        (authenticated.role === "CFO" || authenticated.role === "CGMF") ? (
        props.EmdPaid.lotPaymentViewModel?.paymentNotes !== null &&
        props.EmdPaid.lotPaymentViewModel?.paymentNotes !== "" &&
        props.viewTransferDetails.length === 0 ? (
          <>
            <CCol xl={12} className="mt-2 pl-1 pr-1">
              <h3 className="titlehr">Security Deposit Payment</h3>
              {props.EmdPaid.lotPaymentViewModel?.paymentNotes}

              {props.viewListDetails?.chequePaymentNotes !== null &&
                props.viewListDetails?.chequePaymentNotes !== "" &&
                props.EmdPaid.lotPaymentViewModel?.paymentNotes !==
                  props.viewListDetails?.chequePaymentNotes && (
                  <>
                    <br />
                    {props.viewListDetails?.chequePaymentNotes}
                  </>
                )}
              {props.EmdPaid.lotPaymentViewModel?.paymentNotes !== "" &&
              props.EmdPaid.lotPaymentViewModel?.tranId !== null ? (
                <>
                  <CButton
                    color="info"
                    onClick={() =>
                      props.PaymentStatusViewHanlder(
                        props.EmdPaid.lotPaymentViewModel?.tranId
                      )
                    }
                    className="mr-5 float-right"
                  >
                    View Receipt
                  </CButton>
                  <CButton
                    color="info"
                    className="mr-2 ml-2 float-right"
                    hidden={
                      props.EmdPaid.lotPaymentViewModel.paidBy !== null &&
                      props.EmdPaid.lotPaymentViewModel.paidBy > 0
                        ? false
                        : true
                    }
                    onClick={() =>
                      props.ViewBankTransaction(
                        props.EmdPaid.lotPaymentViewModel.id,
                        "LT"
                      )
                    }
                  >
                    History
                  </CButton>
                </>
              ) : (
                // <a
                //   target="_blank"
                //   href={`${downloadUrl}/${props.EmdPaid.lotPaymentViewModel.filePath}`}
                //   rel="noreferrer"
                // >
                props.EmdPaid.lotPaymentViewModel.filePath !== null && (
                  <CButton
                    color="info"
                    className="mr-5 float-right"
                    onClick={() =>
                      props.BGPaymentStatusViewHanlder(
                        props.EmdPaid.lotPaymentViewModel.filePath
                      )
                    }
                  >
                    View BG
                  </CButton>
                )
                // </a>
              )}

              {/* <CButton
                      color="info"
                      hidden={props.viewTransferDetails.length === 0  ? false : true }
                      onClick={() =>
                        props.PaymentStatusViewHanlder(props.EmdPaid.lotPaymentViewModel?.tranId)
                      }
                      className="mr-5 mt-1 float-right"
                    >
                      View Receipt
                  </CButton> */}
            </CCol>
          </>
        ) : (
          ""
        )
      ) : (
        ""
      )}
    </>
  );
};

export default LotListViewEMDAndSecurityDepositPayment;
